// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ExternalLink_link__upBtd {\n  color: black;\n  text-decoration: underline;\n}\n", "",{"version":3,"sources":["webpack://./src/components/links/externalLink/ExternalLink.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,0BAA0B;AAC5B","sourcesContent":[".link {\n  color: black;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "ExternalLink_link__upBtd"
};
export default ___CSS_LOADER_EXPORT___;
